import { useEffect, useState } from "react";
import { animate, motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Count({ value }) {
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    const controls = animate(0, value, {
      duration: 1.4,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [value]);
  return <>{display.toLocaleString()}</>;
}

const FALLBACK = [
  ["99.8%", "shift attendance rate"],
  ["0%", "agency cut from guard pay"],
  ["100%", "SIA-licensed guards"],
];

export default function LiveStats() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${API}/stats`)
      .then((r) => (r.ok ? r.json() : null))
      .then(setStats)
      .catch(() => {});
  }, []);

  const items = stats
    ? [
        [stats.waitlist, "on the launch list"],
        [stats.members, "accounts created"],
        [stats.founding_passes, "founding passes claimed"],
      ]
    : FALLBACK;

  return (
    <motion.div
      data-testid="live-stats"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1.2, duration: 0.8 }}
      className="mt-12 flex flex-wrap gap-x-10 gap-y-4 border-t border-white/5 pt-6"
    >
      {items.map(([v, l]) => (
        <div key={l}>
          <p data-testid={`stat-${l.replace(/\s+/g, "-")}`} className="font-display text-2xl font-extrabold text-slate-50">
            {typeof v === "number" ? <Count value={v} /> : v}
          </p>
          <p className="font-mono-tag text-[9px] text-slate-500">{l}</p>
        </div>
      ))}
      {stats && (
        <div className="flex items-end">
          <span className="flex items-center gap-1.5 pb-1">
            <span className="animate-pulse-dot h-1.5 w-1.5 rounded-full bg-emerald-500" />
            <span className="font-mono-tag text-[8px] text-emerald-400">Live from the database</span>
          </span>
        </div>
      )}
    </motion.div>
  );
}
